import { render, staticRenderFns } from "./cameras.vue?vue&type=template&id=bbe20152&"
import script from "./cameras.vue?vue&type=script&lang=js&"
export * from "./cameras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports